// Экран входа: карточка 420 px по центру. Геометрия — из design/README.md, экран 1.

import { useEffect, useRef, useState } from 'react'
import { useAppStore } from '../store/appStore'
import './Login.css'

export default function Login() {
  const host = useAppStore((s) => s.host)
  const pending = useAppStore((s) => s.loginPending)
  const error = useAppStore((s) => s.loginError)
  const login = useAppStore((s) => s.login)
  const theme = useAppStore((s) => s.theme)
  const toggleTheme = useAppStore((s) => s.toggleTheme)
  const profiles = useAppStore((s) => s.profiles)
  const profile = useAppStore((s) => s.profile)
  const selectProfile = useAppStore((s) => s.selectProfile)

  const [password, setPassword] = useState('')
  const field = useRef<HTMLInputElement>(null)

  useEffect(() => {
    field.current?.focus()
  }, [])

  // Смена профиля — это смена пароля: набранное уже не подойдёт.
  const pickProfile = (name: string) => {
    if (name === profile) return
    selectProfile(name)
    setPassword('')
    field.current?.focus()
  }

  // Enter в поле пароля = submit формы = вход.
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (pending || password.length === 0) return
    void login(password)
  }

  return (
    <div className="ab-login">
      <form className="ab-login__card" onSubmit={onSubmit}>
        <div className="ab-login__top">
          <div className="ab-login__brand">
            <span className="ab-login__dot" />
            <span className="ab-login__name">agentbox</span>
          </div>
          <button
            type="button"
            className="ab-login__theme"
            onClick={toggleTheme}
            title="переключить тему"
          >
            {theme === 'dark' ? 'светлая тема' : 'тёмная тема'}
          </button>
        </div>

        <div className="ab-login__head">
          <h1 className="ab-login__title">Вход на сервер</h1>
          <p className="ab-login__lead">
            Соединение держится на сервере: закрытая вкладка не убивает сессию агента.
          </p>
        </div>

        <div className="ab-login__field">
          <span className="ab-login__label">Хост</span>
          <div className="ab-login__host">{host}</div>
        </div>

        {profiles.length > 1 ? (
          <div className="ab-login__field">
            <span className="ab-login__label">Профиль</span>
            <div className="ab-login__profiles" role="group" aria-label="профиль панели">
              {profiles.map((item) => (
                <button
                  key={item.name}
                  type="button"
                  className={`ab-login__profile${item.name === profile ? ' is-on' : ''}`}
                  aria-pressed={item.name === profile}
                  onClick={() => pickProfile(item.name)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ) : null}

        <div className="ab-login__field">
          <label className="ab-login__label" htmlFor="ab-password">
            Пароль доступа
          </label>
          <input
            id="ab-password"
            ref={field}
            className="ab-login__input"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••••••"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        {error ? (
          <div className="ab-login__error" role="alert">
            {error}
          </div>
        ) : null}

        <button type="submit" className="ab-login__submit" disabled={pending || password.length === 0}>
          {pending ? 'подключаюсь…' : 'Подключиться'}
        </button>

        <div className="ab-login__foot">
          <span>сессии живут на сервере</span>
          <span>reconnect: авто</span>
        </div>
      </form>
    </div>
  )
}
